import React from 'react';
import {
    Edit,
    SimpleForm,
    TextField,
    Labeled,
    SelectInput,
    DateTimeInput,
    DateInput,
    AutocompleteInput,
    ReferenceInput,
    FormDataConsumer,
    useTranslate,
    NumberInput,
    ReferenceArrayInput,
} from 'react-admin';
import {AutocompleteArrayInput, DutyField, fullNameText, OneTimeDutyInput} from "../../components";
import {NO_ORDER_BONUS, ORDER_BONUSES, ORDER_STATUS} from "./constants";
import {positiveNumber} from "../../data/validation";
import {ACTIVITY_TYPE} from "../activity/constants";
import {dateToUtcString} from "../../components/utils";
import RichTextInput from "ra-input-rich-text";
import {RaBox} from "ra-compact-ui";
import {diffInMinutes, prettyTimeString} from "../activity/utils";
import QrCodeIcon from '@mui/icons-material/QrCode';


export const OrderEdit = ({permissions, ...props}) => {
    const translate = useTranslate();

    return <Edit mutationMode='pessimistic' {...props}>
        <SimpleForm redirect={(basePath) => `${basePath}${props?.location?.search}`}>
            <TextField source="code"/>
            <RichTextInput source="serviceReport"/>
            <SelectInput source="status" choices={ORDER_STATUS}/>
            <RaBox display="flex" fullWidth>
                <FormDataConsumer>
                    {({formData, ...rest}) => formData.oneTimeDuty
                        ? <DateTimeInput
                            {...rest}
                            source="realizationDate"
                            label="resources.orders.fields.oneTimeDuty.realizationDate"
                            parse={value => value}
                            style={{marginRight: "20px", width: "256px"}}
                        />
                        : <DateInput
                            {...rest}
                            source="realizationDate"
                            label="resources.orders.fields.realizationDate"
                            parse={dateToUtcString}
                            style={{marginRight: "20px", width: "256px"}}
                        />
                    }
                </FormDataConsumer>
                <FormDataConsumer>
                    {({ formData, ...rest }) => (
                        <div style={{ display: 'flex' }}>
                            <div style={{ position: 'relative' }}>
                                <DateTimeInput
                                    source="startRealizationDateTime"
                                    label="resources.orders.fields.startRealizationDateTime"
                                    parse={value => value}
                                    style={{ marginRight: "20px", width: "256px" }}
                                    {...rest}
                                />
                                {formData?.startRealizationDateTimeFromQr && (
                                    <QrCodeIcon style={{position: 'absolute', top: '10px', right: '32px', fontSize: '20px'}} />
                                )}
                            </div>
                            <div style={{ position: 'relative' }}>
                                <DateTimeInput
                                    source="endRealizationDateTime"
                                    label="resources.orders.fields.endRealizationDateTime"
                                    parse={value => value}
                                    style={{ marginRight: "20px", width: "256px" }}
                                    {...rest}
                                />
                                {formData?.endRealizationDateTimeFromQr && (
                                    <QrCodeIcon style={{position: 'absolute', top: '10px', right: '32px', fontSize: '20px'}} />
                                )}
                            </div>

                        </div>
                    )}
                </FormDataConsumer>
                <FormDataConsumer>
                    {({formData}) => <Labeled label="resources.orders.fields.diffRealizationDateTime"
                                              style={{marginRight: "20px", width: "256px"}}>
                        <TextField
                            source="diffRealizationDateTime"
                            record={{
                                diffRealizationDateTime: formData &&
                                    prettyTimeString(diffInMinutes(formData?.startRealizationDateTime, formData?.endRealizationDateTime))
                            }}
                        />
                    </Labeled>}
                </FormDataConsumer>
            </RaBox>
            <SelectInput source="bonus" choices={ORDER_BONUSES} defaultValue={NO_ORDER_BONUS}/>
            <NumberInput
                source="overrideMinutes"
                min={0}
                validate={positiveNumber}
            />
            <SelectInput
                source="overrideActivityType"
                choices={ACTIVITY_TYPE}
                resettable
            />
            <RaBox display="flex" fullWidth>
                <span style={{marginRight: "20px", width: "256px", display: "inline-block"}}>
                <ReferenceInput
                    source="assignee"
                    reference="employees"
                    sort={{field: 'lastName', order: 'ASC'}}
                    filter={{active: true}}
                    filterToQuery={searchText => ({fullName: searchText})}
                    label='resources.orders.fields.assignee'
                    parse={value => value && ({id: value})}
                    format={value => value ? value.id : value}
                    allowEmpty allowNull={null}
                    fullWidth
                >
                    <AutocompleteInput
                        optionText={fullNameText(translate('resources.orders.fields.noAssignee'))}
                    />
                </ReferenceInput>
                </span>
                <FormDataConsumer>
                    {({formData}) =>
                        <span style={{marginRight: "20px", width: "531px", display: "inline-block"}}>
                            <ReferenceArrayInput
                                source="helpers"
                                reference="employees"
                                sort={{field: 'lastName', order: 'ASC'}}
                                filter={{active: true, withoutAssigneeId: formData?.assignee?.id}}
                                filterToQuery={searchText => ({fullName: searchText})}
                                label='resources.orders.fields.helpers'
                                parse={value => (value && value.map(v => ({id: v})))}
                                format={value => (value && value.map(v => v && v.id))}
                                fullWidth
                            >
                                <AutocompleteArrayInput
                                    optionText={fullNameText(translate('resources.orders.fields.noAssignee'))}
                                />
                            </ReferenceArrayInput>
                        </span>
                    }
                </FormDataConsumer>
            </RaBox>
            <RichTextInput source="note"/>
            <FormDataConsumer>
                {({formData}) => {
                    return formData.oneTimeDuty
                        ? <OneTimeDutyInput/>
                        : <Labeled fullWidth label="resources.orders.fields.duty.name">
                            <DutyField source="duty" record={formData}/>
                        </Labeled>
                }}
            </FormDataConsumer>
        </SimpleForm>
    </Edit>
};

export default OrderEdit;